import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../../../common/html/element'
import { Icon } from '../../../../../../../../common/html/icon'
import { Tooltip } from '../../../../../../../../common/tooltip'
import {
  FORMAT,
  formatDateTime,
} from '../../../../../../../../helpers/datetime'
import { formatText } from '../../../../../../../../helpers/value'

export const CustomTdScore = ({ val, locale, isDynamicReport }) => {
  const { creditRiskScore, publicDate, colorCode } = val

  return (
    <Element className="dFlex justifyContentCenter">
      <Element
        className="dFlex justifyContentCenter alignItemsCenter"
        style={{
          backgroundColor: colorCode,
          fontWeight: 600,
          width: 60,
          color: '#3A414B',
        }}
      >
        <Element>
          {creditRiskScore === 0 ? '0' : formatText(creditRiskScore)}
        </Element>
        {!isDynamicReport && (
          <Tooltip
            tooltipContent={
              <div className="dFlex gap1">
                <Translate value="score.main.LAST_UPDATE_DATE" />
                {formatDateTime(publicDate, FORMAT.DATE, locale)}
              </div>
            }
          >
            <Icon
              className="icon-info-circle"
              style={{
                fontSize: 10,
                paddingLeft: 5,
              }}
            />
          </Tooltip>
        )}
      </Element>
    </Element>
  )
}
